/* eslint-disable */
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
/* Components */
import Button from "../components/button/button";
import CardHistoryList from "../components/cardHistory/card-history-list";
import cardsDataH from "../components/cardHistory/cardsDataH";
/* Assets */
import ArrowBack from "../assets/icons/arrow_back.svg";
import UserProfileImg from "../assets/icons/Img_profile.svg";
import UserIcon from "../assets/icons/user_icon.svg";
//import HourWatch from '../assets/icons/watch_later.svg';
import { Controller, useForm } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import { updateProfile } from "../services/auth.service";
import useSnackbarStore from "../store/snackbarStore";
import { useMixPanel } from "../hooks/useMixPanel";
import { MIX_PANEL_EVENTS } from "../utils/constans";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parseISO } from "date-fns";
import { getInstitutionsByName, storeInstitution } from "../services/institution";
import debounce from "lodash.debounce";
import AsyncSelect from "react-select/async";
import {
  getCityByCountryAndRegion,
  getCountries,
  getRegionByCountry,
} from "../services/location.service";
import ReactSelect from "react-select";
import ModalForm from '../components/form-elements/modal-form/modalForm';

const Profile = () => {
  const { t, i18n } = useTranslation();
  const [isActive, setIsActive] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [, setDebouncedSearchTerm] = useState("");
  const [isView, setIsView] = useState("perfil");
  const [loading, setLoading] = useState(false);
  const { show } = useSnackbarStore();
  const { sendEvent } = useMixPanel();
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [regions, setRegions] = useState([]);
  const [countries, setCountries] = useState([]);
  const [cities, setCities] = useState([]);
  const [institutionRegions, setInstitutionsRegions] = useState([]);
  const [institutionCountries, setInstitutionsCountries] = useState([]);
  const [institutionCities, setInstitutionsCities] = useState([]);

  const SelectStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "rgb(182 182 182 / 0.5)",
      borderColor: "transparent",
      borderRadius: "8px",
      caretColor: "white",
      "&:hover": { borderColor: "transparent" }, // Borde en hover
    }),
    input: (provided) => ({
      ...provided,
      color: "rgb(38, 38, 38)",
      fontWeight: "bold", // Establece el color del texto del input a blanco
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#F2F2F2" : "#FEFEFE",
      color: "black",
      cursor: "pointer",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#FEFEFE", // Color del indicador
      "&:hover": {
        color: "#3FB2E3", // Color del indicador en hover
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "rgb(38, 38, 38)", // Establece el color del texto de la opción seleccionada a blanco
      fontWeight: "bold",
    }),
  };

  const {
    handleSubmit,
    register,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const queryClient = useQueryClient();
  const newInstitution = watch("newInstitution");
  const selectedCountryCode = watch("country_id");
  const selectedRegion = watch("region_id");
  const selectedCity = watch("city_id");
  const selectedInstitutionCountry = watch("country_institution");
  const selectedInstitutionRegion = watch("region_institution");
  const selectedInstitutionCity = watch("city_institution");

  useEffect(() => {
    const localStorageUser = localStorage.getItem("user");
    const user = localStorageUser ? JSON.parse(localStorageUser) : null;
    if (user) {
      let formattedBirthday = null;
      if (user.birthday) {
        const dateObject = parseDateString(user.birthday);
        if (!isNaN(dateObject.getTime())) {
          formattedBirthday = format(dateObject, "dd-MM-yyyy");
        }
      }
      console.log('user ', user);
      const name = `${user.first_name} ${user.last_name}`;
      const formData = {
        profile: user.bio || "",
        country: user.country ? { value: Number(user.country) } : "",
        city: user.city || "",
        phone: user.phone || "",
        email: user.email || "",
        birthday: formattedBirthday || "",
        number_students: user.number_students || "",
        teaching_area: user.teaching_area || "",
        name: name || "",
        country_id: user.country?.country_id,
        region_id: user.region?.region_id,
        city_id: user.city?.city_id,

      };
      Object.keys(formData).forEach((key) => {
        setValue(key, formData[key], { shouldValidate: true });
      });
      if(user?.institution?.id){
        getInstitutionsByName(user.institution.name).then((res) => {
          const findInstitution = res.find((e) => e.id === user.institution.id);
          if (findInstitution) {
            setValue("institution", {
              label: findInstitution.name,
              value: findInstitution.id,
            });
          }
        });
      }
    }
    // eslint-disable-next-line
  }, []);
  /* eslint-disable */
  useEffect(() => {
    if (!isDisabled) {
      console.log("isDisabled ", isDisabled);
      sendEvent(MIX_PANEL_EVENTS.editProfile);
    }
  }, [isDisabled]);

    // Actualiza debouncedSearchTerm después de que el usuario deja de escribir
  useEffect(() => {
    // Crea una función debounced que actualiza debouncedSearchTerm
    const debouncedUpdate = debounce((search) => {
      setDebouncedSearchTerm(search);
    }, 500); // 500 ms de espera

    if (searchTerm) {
      debouncedUpdate(searchTerm);
    }

    // Limpia el debounce si el componente se desmonta o el searchTerm cambia
    return () => debouncedUpdate.cancel();
    // eslint-disable-next-line
  }, [searchTerm]);

  const mutation = useMutation(updateProfile, {
    onSuccess: (data) => {
      queryClient.setQueryData(["update-profile"], data?.data);
      localStorage.setItem("user", JSON.stringify(data?.user));
      setValue("profile", data?.user?.bio);
      setValue("country", data?.user?.country);
      setValue("city", data?.user?.city);
      setValue("phone", data?.user?.phone);
      setValue("email", data?.user?.email);
      setValue("birthday", data?.user?.birthday);
      setValue("number_students", data?.user?.number_students);
      setValue("teaching_area", data?.user?.teaching_area);
      if(data?.user?.institution){
        setValue(
          "institution",
          { label: data?.user?.institution.name, value: data?.user?.institution.id },
          { shouldValidate: true }
        );
      }
      
      setValue("name", `${data?.user?.first_name} ${data?.user?.last_name}`);
      show(`${t("perfil_actualizado")}!`);
      sendEvent(MIX_PANEL_EVENTS.saveProfile);
      setLoading(false);
    },
    onError: (error) => {
      if (error?.response.status === 401) {
        show(error.response.data.message, "error");
      }
      setLoading(false);
    },
  });


  const mutationStoreInstitution = useMutation(storeInstitution, {
    onSuccess: (data) => {
      getInstitutionsByName(data?.name).then((institutions) => {
        if (institutions.length > 0) {
          const newInstitution = institutions[0];
          setValue(
            "institution",
            { label: newInstitution.name, value: newInstitution.id },
            { shouldValidate: true }
          );
          setShowModal(false);
        }
      });
    },
    onError: (error) => {
      console.log("Error al registrar la institución", error);
      // Maneja el error según sea necesario
    },
  });

  const mutationCountries = useMutation(getCountries, {
    onSuccess: (data) => {
      const countryOptions = data.map((country) => ({
        value: country.country_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setCountries(countryOptions);
      setInstitutionsCountries(countryOptions);
      const localStorageUser = localStorage.getItem("user");
      const user = localStorageUser ? JSON.parse(localStorageUser) : null;
      if(user?.country){
        const findCountry = countryOptions.find(e => e.value === Number(user.country));
        if(findCountry){
          setValue("country_institution",findCountry.value)
          setValue("country_id",findCountry.value)
        }
      }
    },
    onError: (error) => {},
  });

  const mutationInstitutionCountries = useMutation(getCountries, {
    onSuccess: (data) => {
      const countryOptions = data.map((country) => ({
        value: country.country_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setInstitutionsCountries(countryOptions);
    },
    onError: (error) => {},
  });

  const mutationRegions = useMutation(getRegionByCountry, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.region_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setRegions(options);
      setInstitutionsRegions(options);
    },
    onError: (error) => {},
  });

  const mutationInstitutionRegions = useMutation(getRegionByCountry, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.region_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setInstitutionsRegions(options);
    },
    onError: (error) => {},
  });

  const mutationCity = useMutation(getCityByCountryAndRegion, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.city_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setCities(options);
      setInstitutionsCities(options);
    },
    onError: (error) => {},
  });

  const mutationInstitutionCity = useMutation(getCityByCountryAndRegion, {
    onSuccess: (data) => {
      const options = data.map((country) => ({
        value: country.city_id,
        label: i18n.language === "es" ? country.title_es : country.title_en,
      }));
      setInstitutionsCities(options);
    },
    onError: (error) => {},
  });

  // eslint-disable-next-line
  const debouncedLoadOptions = useCallback(
    debounce((inputValue, callback) => {
      if (!inputValue) {
        callback([]);
        return;
      }

      // useCallback para memorizar la función debounced
      getInstitutionsByName(inputValue).then((institutions) => {
        const options = institutions.map((institution) => ({
          label: institution.name,
          value: institution.id,
        }));
        if (options.length === 0) {
          // Si no hay opciones, muestra el modal
          setShowModal(true);
          setValue("newInstitution", inputValue);
        } else {
          setValue("newInstitution", "");
          // Si hay opciones, asegúrate de que el modal no se muestre
          setShowModal(false);
        }
        callback(options);
      });
    }, 1000),
    []
  );

  // eslint-disable-next-line
  const loadInstitutionOptions = (inputValue, callback) => {
    debouncedLoadOptions(inputValue, callback);
  };

  const parseDateString = (originalValue) => {
    if (typeof originalValue === "string") {
      const [day, month, year] = originalValue.split("-");
      return new Date(year, month - 1, day);
    }
    return null;
  };

  const toggleClass = () => {
    setIsActive(!isActive);
  };

  const toggleInput = () => {
    console.log("isDisabled ", isDisabled);
    if (!isDisabled) {
      handleSubmit(onSubmit)(); // Envía el formulario
    } else {
      setIsDisabled(!isDisabled); // Activa la edición
    }
  };

  const toggleView = (buttonName) => {
    setIsView(buttonName);
  };

  const onSubmit = (data) => {
    if (!isDisabled) {
      const localUser = localStorage.getItem(
        "user",
        JSON.stringify(data?.user)
      );
      if (localUser) {
        const {
          email,
          phone,
          birthday,
          city,
          country,
          bio,
          institution,
          number_students,
          teaching_area,
          name,
        } = data;
        
        const user = JSON.parse(localUser);
        setLoading(true);
        const spaceIndex = name.indexOf(" ");
        const firstName = name.substring(0, spaceIndex);
        const lastName = name.substring(spaceIndex + 1);
        const payload = {
          first_name: firstName,
          last_name: lastName,
          email,
          phone,
          birthday,
          country: selectedCountryCode,
          state: selectedRegion,
          city: selectedCity,
          bio,
          institution: institution?.value || null,
          number_students,
          teaching_area,
        };
        mutation.mutate({ id: user.id, payload });
      }
    }
  };

  const getButtonText = () => {
    if (loading) return `${t("perfil_guardando")} ...`;
    if (!loading && !isDisabled) return t("perfil_guardar");
  };


  const handleRegisterInstitution = () => {
    const payload = {
      name: newInstitution,
      country: selectedInstitutionCountry,
      state: selectedInstitutionRegion,
      city: selectedInstitutionCity,
    };
    mutationStoreInstitution.mutate(payload);
  };

  useEffect(() => {
    if (selectedCountryCode) {
      mutationRegions.mutate({ country: selectedCountryCode, lang: i18n.language });
    }
    // eslint-disable-next-line
  }, [selectedCountryCode, setValue]);

  useEffect(() => {
    if (selectedRegion) {
      mutationCity.mutate({
        country: selectedCountryCode,
        region: selectedRegion,
        lang: i18n.language
      });
    }
    // eslint-disable-next-line
  }, [selectedRegion]);

  useEffect(() => {
    if (selectedInstitutionCountry) {
      mutationInstitutionRegions.mutate({ country: selectedInstitutionCountry, lang: i18n.language });
    }
    // eslint-disable-next-line
  }, [selectedInstitutionCountry]);

  useEffect(() => {
    if (selectedInstitutionRegion) {
      mutationInstitutionCity.mutate({
        country: selectedInstitutionCountry,
        region: selectedInstitutionRegion,
        lang: i18n.language 
      });
    }
    // eslint-disable-next-line
  }, [selectedInstitutionRegion]);

  useEffect(() => {
    if (showModal) {
      mutationInstitutionCountries.mutate(i18n.language );
    }
    // eslint-disable-next-line
  }, [showModal]);

  useEffect(() => {
    mutationCountries.mutate(i18n.language );
    // eslint-disable-next-line
  }, []); 

  return (
    <>
      <div className="back-button">
        <Link to={"/"} className="back-button_arrow">
          <img src={ArrowBack} className="" alt="" /> {t("inicio")}
        </Link>
        <span className="back_button_root">Shaia /</span>
        <span className="back_button_page">{t("my_profile")}</span>
      </div>
      <div className="wrapper page">
        <div className={`main_sidebar ${isActive ? "active" : ""}`}>
          <ul className="sidebar-buttons">
            <li
              className={`sidebar-button ${
                isView === "perfil" ? "active" : ""
              }`}
              onClick={() => toggleView("perfil")}
            >
              <span className="sidebar-button_icon">
                <img src={UserIcon} alt="" />
              </span>
              <p className="sidebar-button_label">{t("perfil_tu_perfil")}</p>
            </li>
            {/*<li
              className={`sidebar-button ${
                isView === "historial" ? "active" : ""
              }`}
              onClick={() => toggleView("historial")}
            >
              <span className="sidebar-button_icon">
                <img src={HourWatch} alt="" />
              </span>
              <p className="sidebar-button_label">Tu historial</p>
            </li>*/}
          </ul>
          <Button label="Cerrar" variant="primary" onClick={toggleClass} />
        </div>
        {isView === "perfil" && (
          <form className="main_board" onSubmit={handleSubmit(onSubmit)}>
            <div className="main_board-header">
              <div className="header-imgprofile">
                <img src={UserProfileImg} className="profile" alt="profile" />
              </div>
              <div className="header-textprofile">
                <Controller
                  name="name"
                  control={control}
                  rules={{
                    required: "Este campo es requerido",
                  }}
                  render={({ field }) => (
                    <input
                      {...field}
                      className={isDisabled ? "input-profile" : "input-box"}
                      disabled={!loading && isDisabled}
                    />
                  )}
                />
                {isDisabled && (
                  <Button
                    label={t("perfil_editar_perfil")}
                    variant={"primary"}
                    onClick={toggleInput}
                    disabled={loading}
                  />
                )}
              </div>
            </div>
            <div className="main_board-body">
              <div className="input-text mt-2">
                <label className="input-label">{t("my_profile")}</label>
                <Controller
                  name="bio"
                  control={control}
                  defaultValue=""
                  rules={{
                    required: "Este campo es requerido",
                  }}
                  render={({ field }) => (
                    <textarea
                      {...field}
                      className="input-box"
                      rows="4"
                      cols="50"
                      placeholder="Personaliza tu experiencia. Comparte tus intereses y áreas de expertise."
                      disabled={!loading && isDisabled}
                    />
                  )}
                />
              </div>
              <div className="input-row">
                <div className="input-text">
                  <label className="input-sub-label">
                    {t("perfil_nacimiento")}
                  </label>
                  <Controller
                    name="birthday"
                    rules={{ required: "Este campo es requerido" }}
                    control={control}
                    render={({ field, fieldState, formState, ref }) => {
                      const dateValue =
                        field.value && !isNaN(new Date(field.value).getTime())
                          ? parseISO(
                              format(new Date(field.value), "yyyy-MM-dd")
                            )
                          : null;
                      return (
                        <DatePicker
                          {...field}
                          selected={dateValue}
                          onChange={(date) =>
                            field.onChange(format(date, "dd-MM-yyyy"))
                          }
                          className="input-box"
                          dateFormat="dd-MM-dd"
                          placeholderText={t("perfil_placeholder_dia_mes_ano")}
                          disabled={!loading && isDisabled}
                          ref={ref} // Asegurarse de que la referencia es pasada al DatePicker
                        />
                      );
                    }}
                  />
                  {errors.birthday && (
                    <span className="error">{errors.birthday.message}</span>
                  )}
                </div>
                <div className="input-text">
                  <label className="input-sub-label">{t("institution")}</label>
                  <Controller
                    name="institution"
                    control={control}
                    rules={{ required: t("campo_requerido") }}
                    render={({ field }) => (
                      <AsyncSelect
                        {...field}
                        cacheOptions
                        defaultOptions
                        loadOptions={loadInstitutionOptions}
                        onInputChange={(value) => {
                          setSearchTerm(value); // Actualiza el término de búsqueda basado en la entrada del usuario
                        }}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption); // Informa a react-hook-form sobre el cambio
                          setValue("institution", selectedOption, {
                            shouldValidate: true,
                          }); // Establece el valor seleccionado y activa la validación
                        }}
                        value={field.value} // Valor seleccionado se muestre correctamente
                        styles={SelectStyles}
                        placeholder={t(
                          "registro_campo_institution_placeholder"
                        )}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        disabled={!loading && isDisabled}
                      />
                    )}
                  />
                  {errors.institution && (
                    <span className="error">{errors.institution.message}</span>
                  )}
                </div>
              </div>
              <div className="input-row">
                <div className="input-text">
                  <label className="input-sub-label">
                    {t("perfil_area_de_enseñanza")}
                  </label>
                  <Controller
                    name="teaching_area"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: "Este campo es requerido",
                    }}
                    render={({ field }) => (
                      <input
                        {...field}
                        className="input-box"
                        disabled={!loading && isDisabled}
                        placeholder={"Español"}
                      />
                    )}
                  />
                  {errors.teaching_area && (
                    <span className="error">
                      {errors.teaching_area.message}
                    </span>
                  )}
                </div>
                <div className="input-text">
                  <label className="input-sub-label">
                    {t("perfil_numero_de_estudiantes")}
                  </label>
                  <Controller
                    name="number_students"
                    control={control}
                    defaultValue=""
                    rules={{
                      required: "Este campo es requerido",
                    }}
                    render={({ field }) => (
                      <input
                        {...field}
                        className="input-box"
                        disabled={!loading && isDisabled}
                        placeholder={"60"}
                      />
                    )}
                  />
                  {errors.number_students && (
                    <span className="error">
                      {errors.number_students.message}
                    </span>
                  )}
                </div>
              </div>
              <div className="input-row">
                <div className="input-text">
                  <label className="input-sub-label">{t("perfil_pais")}</label>
                  <Controller
                    name="country_id"
                    control={control}
                    rules={{ required: t("campo_requerido") }}
                    render={({ field }) => (
                      <ReactSelect
                        {...field}
                        value={countries.find(
                          (option) => option.value === field.value
                        )}
                        options={countries}
                        placeholder={t("seleccionar_pais")}
                        onChange={(option) => {
                          console.log("option ", option);
                          if (typeof option === "object" && option !== null) {
                            setValue("country_institution", option.value);
                            field.onChange(option.value);
                          }
                        }}
                        styles={SelectStyles}
                        isMulti={false}
                        maxMenuHeight={100}
                        menuPlacement="bottom"
                        disabled={!loading && isDisabled}
                      />
                    )}
                  />
                  {errors.country_id && (
                    <span className="error">{errors.country_id.message}</span>
                  )}
                </div>
                {/* <div className="input-text">
                  <label className="input-sub-label">
                    {t("registro_qEstado")}
                  </label>
                  <Controller
                    name="region_id"
                    control={control}
                    rules={{ required: t("campo_requerido") }}
                    disabled={!selectedCountryCode && !regions.length}
                    render={({ field }) => (
                      <ReactSelect
                        {...field}
                        value={regions.find(
                          (option) => option.value === field.value
                        )}
                        options={regions}
                        placeholder={"Seleccionar Estado"}
                        onChange={(option) => {
                          if (typeof option === "object" && option !== null) {
                            setValue("region_institution", option.value);
                            field.onChange(option.value);
                          }
                        }}
                        styles={SelectStyles}
                        isMulti={false}
                        maxMenuHeight={100}
                        menuPlacement="bottom"
                        disabled={!loading && isDisabled}
                      />
                    )}
                  />
                  {errors.region_id && (
                    <span className="error">{errors.region_id.message}</span>
                  )}
                </div> */}

                {/* <div className="input-text">
                  <label className="input-sub-label">
                    {t("registro_qCiudad")}
                  </label>
                  <Controller
                    name="city_id"
                    control={control}
                    rules={{ required: t("campo_requerido") }}
                    render={({ field }) => (
                      <ReactSelect
                        {...field}
                        value={cities.find(
                          (option) => option.value === field.value
                        )}
                        options={cities}
                        placeholder={t("seleccionar_ciudad")}
                        onChange={(option) => {
                          if (typeof option === "object" && option !== null) {
                            setValue("ReactSelect", option.value);
                            field.onChange(option.value);
                          }
                        }}
                        styles={SelectStyles}
                        isMulti={false}
                        maxMenuHeight="200px"
                        menuPlacement="bottom"
                        disabled={!loading && isDisabled}
                      />
                    )}
                  />
                  {errors.city_id && (
                    <span className="error">{errors.city_id.message}</span>
                  )}
                </div> */}
              </div>
              <div className="input-text">
                <label className="input-label">{t("perfil_contacto")}</label>
              </div>
              <div className="input-row">
                <div className="input-text">
                  <label className="input-sub-label">
                    {t("perfil_correo")}
                  </label>
                  <Controller
                    name="email"
                    control={control}
                    rules={{
                      required: "Este campo es requerido",
                    }}
                    render={({ field }) => (
                      <input
                        {...field}
                        className="input-box"
                        disabled={!loading && isDisabled}
                        placeholder={t("perfil_correo")}
                      />
                    )}
                  />
                  {errors.email && (
                    <span className="error">{errors.email.message}</span>
                  )}
                </div>
                <div className="input-text">
                  <label className="input-sub-label">
                    {t("perfil_telefono")}
                  </label>
                  <Controller
                    name="phone"
                    rules={{
                      required: "Este campo es requerido",
                    }}
                    control={control}
                    render={({ field }) => (
                      <input
                        {...field}
                        className="input-box"
                        disabled={!loading && isDisabled}
                        placeholder={t("perfil_telefono")}
                      />
                    )}
                  />
                  {errors.phone && (
                    <span className="error">{errors.phone.message}</span>
                  )}
                </div>
                <ModalForm isOpen={showModal}>
                <form className="!bg-transparent !w-full !h-full">
                  {/* <div className='input-text mt-2'>
                    <label className="input-label dark:text-Grey-500 text-DarkBlue-500">Selecciona el tipo de institución</label>
                    <Controller
                      name="institution"
                      control={control}
                      render={({ field }) => (
                        <CheckboxGroup
                          field={field}
                          options={insTypeOptions}
                          inputView={false}
                        />
                      )}
                    />
                  </div> */}
                  <div className="input-row">
                    <div className="input-text mt-2 flex-1">
                      {/* Selector de País */}
                      <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                        {t("registro_campo_pais_titulo")}
                      </label>
                      <Controller
                        name="country_institution"
                        control={control}
                        rules={{ required: showModal ? t("campo_requerido") : false }}
                        render={({ field }) => (
                          <ReactSelect
                            {...field}
                            value={institutionCountries.find(
                              (option) => option.value === field.value
                            )}
                            options={institutionCountries}
                            placeholder={t("registro_campo_seleccione")}
                            onChange={(option) => {
                              if (
                                typeof option === "object" &&
                                option !== null
                              ) {
                                field.onChange(option.value);
                              }
                            }}
                            styles={SelectStyles}
                            isMulti={false}
                            maxMenuHeight={200}
                            menuPlacement="bottom"
                          />
                        )}
                      />
                      {errors.country_institution && (
                        <span className="error">
                          {errors.country_institution.message}
                        </span>
                      )}
                    </div>

                    {/* <div className="input-text mt-2 flex-1">
                   
                      <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                        {t("registro_campo_estado_titulo")}
                      </label>
                      <Controller
                        name="region_institution"
                        control={control}
                        rules={{ required: showModal ? t("campo_requerido") : false }}
                        disabled={
                          !selectedInstitutionCountry &&
                          !institutionRegions.length
                        }
                        render={({ field }) => (
                          <ReactSelect
                            {...field}
                            value={institutionRegions.find(
                              (option) => option.value === field.value
                            )}
                            options={institutionRegions}
                            placeholder={t("registro_campo_seleccione")}
                            onChange={(option) => {
                              if (
                                typeof option === "object" &&
                                option !== null
                              ) {
                                field.onChange(option.value);
                              }
                            }}
                            styles={SelectStyles}
                            isMulti={false}
                            maxMenuHeight={200}
                            menuPlacement="bottom"
                          />
                        )}
                      />
                      {errors.region_institution && (
                        <span className="error">
                          {errors.region_institution.message}
                        </span>
                      )}
                    </div> */}
                  </div>
                  {/* <div className="input-row">
                    <div className="input-text mt-2 flex-1">
                     
                      <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                        {t("registro_campo_ciudad_titulo")}
                      </label>
                      <Controller
                        name="city_institution"
                        control={control}
                        rules={{ required: showModal ? t("campo_requerido") : false }}
                        render={({ field }) => (
                          <ReactSelect
                            {...field}
                            value={institutionCities.find(
                              (option) => option.value === field.value
                            )}
                            disabled={
                              !selectedInstitutionRegion &&
                              !institutionCities.length
                            }
                            options={institutionCities}
                            placeholder={t("registro_campo_seleccione")}
                            onChange={(option) => field.onChange(option.value)}
                            styles={SelectStyles}
                            isMulti={false}
                            maxMenuHeight="200px"
                            menuPlacement="bottom"
                          />
                        )}
                      />
                      {errors.city_institution && (
                        <span className="error">
                          {errors.city_institution.message}
                        </span>
                      )}
                    </div>
                  </div> */}
                  <div className="input-text mt-2">
                    <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                      {t("registro_campo_institution_nombre")}
                    </label>
                    <input
                      className="rounded-2 bg-[#dadada] text-black font-semibold mt-4 p-2"
                      type="text"
                      {...register("newInstitution", {
                        required: showModal ? t("campo_requerido") : false,
                      })}
                    />
                  </div>
                  {/* Improvement */}
                  {/* <div className="input-text mt-2">
                    <label className="input-label dark:text-Grey-500 text-DarkBlue-500">
                    {t("registro_campo_institution_sede")}
                    </label>
                    <input
                      className="input-box"
                      type="text"
                      {...register("newInstitutionHeadquartered")}
                    />
                  </div> */}
                  <div className='w-full flex justify-center' >
                  <Button
                    label={t("registro_campo_institution_boton")}
                    variant="primary"
                    customClassName="mt-6 bg-LightBlue-500"
                    typeB="button"
                    onClick={() => handleRegisterInstitution()}
                  />
                  </div>
                </form>
              </ModalForm>
              </div>
            </div>
            {!isDisabled && (
              <div className="">
                <Button
                  label={getButtonText()}
                  variant={"secondary"}
                  onClick={toggleInput}
                  disabled={loading}
                  customClassName="btn-save_profile"
                />
              </div>
            )}
          </form>
        )}
        {isView === "historial" && (
          <div className={`main_board history_board`}>
            <CardHistoryList cardsData={cardsDataH} />
          </div>
        )}
      </div>
    </>
  );
};

export default Profile;
